<template>
<div class="relative flex flex-col justify-center items-center  w-6/12 rounded-2xl bg-white py-6">
    <span @click="closeModal" class="absolute left-8 top-4 text-customGray text-sm cursor-pointer">Close</span>
    <h2 class="text-center mb-5 font-semibold">What would you like to add?</h2>
    <div class="flex justify-center">
        
        <div @click="connectToFacebook" class="w-7/12 bg-gray-100 text-center flex flex-col justify-center items-center rounded-lg mr-2 py-5 cursor-pointer">
            <FacebookAccount class="m-4"/>
            <h3 class="font-semibold mb-2">Account</h3>
            <p class="text-xs text-customGray w-10/12">Link a FB account whether your churches or a personal</p>
        </div>

        <div @click="connectGroups" class="w-7/12 bg-gray-100 text-center flex flex-col justify-center items-center rounded-lg mr-2 py-5 cursor-pointer">
            <FacebookGroup class="m-4"/>
            <h3 class="font-semibold mb-2">Group</h3>
            <p class="text-xs text-customGray w-10/12">Link FB group associated to an account</p>
        </div>
        
    </div>
</div>
</template>

<script>
import FacebookAccount from '@/components/svg/FacebookAccount';
import FacebookGroup from '@/components/svg/FacebookGroup';

export default {
 name:"FacebookLogin",
  components: {
      FacebookAccount,
      FacebookGroup
  },
 props: {
   provider: {
     type: String,
     default: 'facebook'
   }
 },
 methods: {
   closeModal() {
      this.$emit('closeModal');
   },

   connectGroups() {
      FB.login((response) => {
        if (response.status === 'connected') {
          this.getFacebookProfile(response.authResponse.accessToken, 'group');
        } else {
          console.log('You are not logged in'); 
        }
      }, 
      {
          scope: 'publish_to_groups,groups_access_member_info', 
          return_scopes: true,
          auth_type: 'rerequest,reauthenticate,reauthorize',
          enable_profile_selector: true
      });
    },

   connectToFacebook() {
      FB.login((response) => {
        if (response.status === 'connected') {
          this.getFacebookProfile(response.authResponse.accessToken, 'account');
        } else {
          console.log('You are not logged in'); 
        }
      }, 
      {
          scope: 'email,public_profile,pages_show_list,pages_read_engagement,pages_manage_posts,instagram_content_publish,instagram_basic', 
          return_scopes: true,
          auth_type: 'rerequest,reauthenticate,reauthorize',
          enable_profile_selector: true
      });
    },
    
    getFacebookProfile(accessToken, connectionType) {
      FB.api('/me', 'GET', {"fields":"id,name,email, picture"}, (response) => 
      {
        const payload = {
          user_data: {'id': response.id,
          'email': response.email,
          'name': response.name,
          'picture': response.picture},
          id_token: accessToken,
        }
        this.processFacebookProfile(payload, connectionType);
      });
    },

    processFacebookProfile: async function (payload, connectionType) {
      await this.checkLogin(payload, connectionType);
    },

    checkLogin: async function (payload, connectionType) {
      this.$inertia.post(this.$route('social-accounts.store', connectionType), payload);
      this.$emit('closeModal');
    },
 },
}
</script>